import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import Loading from "../common/Loading";
import { SiteActionCreators } from "../../store/actions/site";

const Dashboard = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const selectedSite = useSelector((state) => state?.site?.selectedSite);
  const integrationType = useSelector(
    (state) => state?.auth?.user?.integrationType
  );

  useEffect(() => {
    dispatch(SiteActionCreators.getSites()).then((res) => {
      if (integrationType === 5) {
        const siteId =
          selectedSite === null ||
          (!selectedSite?.id && !selectedSite?.virgulId)
            ? res?.data?.length > 1
              ? res?.data[1]?.id
              : res?.data[0]?.id
            : selectedSite?.id ?? selectedSite?.virgulId;
        if (!siteId) {
          navigate(`/sites/add`);
          return;
        }
        dispatch(SiteActionCreators.getSite(siteId)).then(() => {
          navigate(`/business/${siteId}`);
        });
      } else if (integrationType === 3 || integrationType === 4) {
        navigate("/apps");
      } else if (integrationType === 1) {
        navigate("/analytics/apps");
      } else if (integrationType === -1) {
        navigate("/videos");
      } else if (res?.data?.length === 0) {
        if (integrationType === -1) {
          navigate("/videos");
        } else {
          navigate("/sites/add");
        }
      } else {
        const siteId =
          selectedSite === null ||
          (!selectedSite?.id && !selectedSite?.virgulId)
            ? res?.data?.length > 1
              ? res?.data[1]?.id
              : res?.data[0]?.id
            : selectedSite?.id ?? selectedSite?.virgulId;
        dispatch(SiteActionCreators.getSite(siteId)).then(() => {
          navigate(`/sites/${siteId}`);
        });
      }
    });
  }, [dispatch, navigate, integrationType, selectedSite]);

  return <Loading />;
};

export default Dashboard;
